import type { CellContext, ColumnDef } from '@tanstack/react-table';
import type { TFunction } from 'i18next';
import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Font } from '@feathr/blackbox';
import type { ITanStackColumnMeta } from '@feathr/components';
import { DateTimeCell, TanStackHeader } from '@feathr/components';
import { TimeFormat } from '@feathr/hooks';

import FontOptions from './FontOptions';

/** Each sortable column `id` is the field the list route orders by. */
function fontsColumns(t: TFunction): Array<ColumnDef<Font>> {
  return [
    {
      accessorFn: (row): string => row.name,
      cell: ({ row }: CellContext<Font, unknown>): JSX.Element => (
        <Observer>{(): JSX.Element => <>{row.original.name}</>}</Observer>
      ),
      header: (): JSX.Element => <TanStackHeader title={t('Font')} />,
      id: 'name',
      meta: { isFlex: true, isPrimary: true } satisfies ITanStackColumnMeta,
      sortDescFirst: false,
    },
    {
      accessorFn: (row): string | undefined => row.get('date_created'),
      cell: ({ row }: CellContext<Font, unknown>): JSX.Element => (
        <Observer>
          {(): JSX.Element => (
            <DateTimeCell
              format={TimeFormat.shortDateTime}
              value={row.original.get('date_created')}
            />
          )}
        </Observer>
      ),
      header: (): JSX.Element => <TanStackHeader title={t('Created')} />,
      id: 'date_created',
      meta: { isFlex: true } satisfies ITanStackColumnMeta,
      sortDescFirst: false,
    },
    {
      cell: ({ row }: CellContext<Font, unknown>): JSX.Element => (
        <FontOptions font={row.original} />
      ),
      enableSorting: false,
      header: (): JSX.Element => <TanStackHeader title={t('Options')} />,
      id: 'options',
      meta: { align: 'center', pinned: 'right' } satisfies ITanStackColumnMeta,
      size: 80,
    },
  ];
}

export default fontsColumns;
